import { ReviewDistributionValue } from "@omni/types/api/reviews/bff/shared/reviewDistributionValue.model";
import { isDefined } from "@omni/utils/helper.utils";
import { isEmpty } from "lodash-es";

import { useReviewsContext } from "@/components/Product/Reviews/context/reviews.context";
import { useWriteReviewContext } from "@/components/Product/Reviews/context/writeReview.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as UseFeatureTracker from "@/services/tracking/trackers/feature/useFeature.tracker";
import { scrollToElementById } from "@/utils/scroll";

import { DefaultRatingSummaryComponent } from "./components/defaultRatingSummary.component";
import { EmptyRatingSummaryComponent } from "./components/emptyRatingsSummary.component";
import { OnlyScoreRatingSummaryComponent } from "./components/onlyScoreRatingsSummary.component";

export type RatingSummaryProps = {
    value?: number;
    count?: number;
    distributions?: Array<ReviewDistributionValue>;
};

const RatingSummary = ({
    value,
    count,
    distributions = []
}: RatingSummaryProps) => {
    const { t } = useGranite();
    const { open: openModal } = useWriteReviewContext();
    const { sku, brand, category } = useReviewsContext();

    const writeReview = () => {
        UseFeatureTracker.track({
            type: "bazaarvoice",
            name: "write",
            sku: sku,
            brand: brand,
            categoryId: category
        });

        openModal();
    };

    const goToReviews = () => {
        UseFeatureTracker.track({
            type: "bazaarvoice",
            name: "link",
            linkType: "review_count",
            sku: sku,
            brand: brand,
            categoryId: category
        });

        scrollToElementById(t("productDetail.anchor.hash.reviews"));
    };

    if (!isDefined(count) || !isDefined(value)) {
        return (
            <EmptyRatingSummaryComponent
                writeReview={writeReview}
                goToReviews={goToReviews}
            />
        );
    } else if (isEmpty(distributions)) {
        return (
            <OnlyScoreRatingSummaryComponent
                count={count}
                value={value}
                writeReview={writeReview}
                goToReviews={goToReviews}
            />
        );
    } else {
        return (
            <DefaultRatingSummaryComponent
                count={count}
                value={value}
                distributions={distributions}
                writeReview={writeReview}
                goToReviews={goToReviews}
            />
        );
    }
};

export { RatingSummary };
